import instance from "@/utils/require.js"

// 维修单--新增送修
export function apiRepairAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/repair/add",
		method: "post",
		data
	})
}

// 维修单--分页查询
export function apiRepairSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/repair/search",
		method: "post",
		data
	})
}

export function apiRepairtDelete(data = {}) {
	return instance({
		url: "/aim/api/v3/repair/delete",
		method: "post",
		data
	})
}
export function apiRepairDetail(data = {}) {
	return instance({
		url: "/aim/api/v3/repair/detail",
		method: "post",
		data
	})
}

//维修记录--导出
export function apiRepairRecordExport(data = {}) {
	return instance({
		url: "/aim/api/v3/repair/export_repair_record",
		method: "post",
		data
	})
}
//统计维修TOP5日报
export function apiRepairReportByDays(data = {}) {
	return instance({
		url: "/aim/api/v3/repair/reportByDays",
		method: "post",
		data
	})
}
